// @flow

import React from 'react';
import { observer } from 'mobx-react';
import FlipMove from 'react-flip-move';
import { css } from 'glamor';

import type { Review as ReviewType } from '~/types';
import Review from '~/components/content/review/Review';

const list = css({
    listStyle: 'none',
    paddingLeft: 0,
});

@observer
export default class ReviewList extends React.Component {
    props: {
        reviews: Array<ReviewType>,
        displayAbout?: boolean,
        summary?: string,
    };

    render() {
        const { reviews, displayAbout, summary } = this.props;

        return (
            <ul { ...list }>
                <FlipMove
                    easing="ease-in-out"
                    enterAnimation="fade"
                    leaveAnimation="fade"
                >
                    {reviews ?
                        reviews.map(review => (
                              <li key={ review.id }>
                                  <Review
                                      review={ review }
                                      displayAbout={ displayAbout }
                                      summary={ summary }
                                  />
                              </li>
                          )) :
                        null}
                </FlipMove>
            </ul>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/content/review/ReviewList.js